module.exports = __webpack_public_path__ + "images/dir-lanhu-68e3243b4fea4427b6337c6000bd4645.png";